/**
 * Google Tag Manager Tracking Helper
 * Utilities for tracking events and conversions with user consent
 */

/**
 * Send event to Google Tag Manager
 * Only sends if user has consented to analytics
 * @param {string} eventName - Name of the event to track
 * @param {Object} eventData - Additional data to send with the event
 */
export const trackEvent = (eventName, eventData = {}) => {
    // Check consent
    const analyticsEnabled = window.HFAnalyticsEnabled;
    const hasConsent = window.HFConsentStatus === 'accepted' || 
                      (window.HFConsentStatus === 'custom' && analyticsEnabled);
    
    if (!hasConsent || !window.dataLayer) {
        console.log('Analytics disabled or no consent - event not tracked:', eventName);
        return;
    }
    
    // Send to GTM dataLayer
    const eventPayload = {
        'event': eventName,
        ...eventData
    };
    window.dataLayer.push(eventPayload);
    
    // CRITICAL: Also send directly to GA4 as fallback
    // This ensures GA4 receives events even if GTM Configuration tag isn't set up
    // This guarantees data flows to GA4 regardless of GTM configuration
    if (window.gtag && window.GA4_INITIALIZED) {
        // Send event directly to GA4
        window.gtag('event', eventName, {
            ...eventData
        });
    }
    
    console.log('Event tracked:', eventName, eventData);
};

/**
 * Track form submission event
 * @param {string} formType - Type of form (e.g., 'contact_form', 'newsletter_subscription')
 * @param {Object} formData - Additional form data to track
 */
export const trackFormSubmission = (formType, formData = {}) => {
    trackEvent('form_submission', {
        'form_type': formType,
        'form_name': formType,
        ...formData
    });
};

/**
 * Track conversion event
 * @param {string} conversionType - Type of conversion
 * @param {Object} value - Additional conversion data
 */
export const trackConversion = (conversionType, value = {}) => {
    trackEvent('conversion', {
        'conversion_type': conversionType,
        ...value
    });
};

/**
 * Track page view (useful for SPAs)
 * @param {string} pagePath - Path of the page
 * @param {string} pageTitle - Title of the page
 */
export const trackPageView = (pagePath, pageTitle) => {
    trackEvent('page_view', {
        'page_path': pagePath,
        'page_title': pageTitle
    });
};

